import { Image, Text, View } from '@react-pdf/renderer';
import { IMAGE_PATHS } from 'constants/imagePaths';

const PersonalInfo = ({
	styles,
	data: { countryCode = '', phoneNumber = '', address = '', email = '', website = '' },
}: any) => {
	return (
		<View style={styles.mainBox}>
			<View style={styles.mainBoxInner}>
				{(phoneNumber || countryCode) && (
					<View style={styles.detailBox}>
						<View>
							<Image style={styles.detailIcon} src={IMAGE_PATHS.templatePhoneIcon} />
						</View>
						<View>
							<Text style={styles.detailText}>
								+({countryCode}) {phoneNumber}
							</Text>
						</View>
					</View>
				)}

				{address && (
					<View style={styles.detailBox}>
						<View>
							<Image style={styles.detailIcon} src={IMAGE_PATHS.templateAddressIcon} />
						</View>
						<View>
							<Text style={styles.detailText}>{address}</Text>
						</View>
					</View>
				)}

				{email && (
					<View style={styles.detailBox}>
						<View>
							<Image style={styles.detailIcon} src={IMAGE_PATHS.templateEmailIcon} />
						</View>
						<View>
							<Text style={styles.detailText}>{email}</Text>
						</View>
					</View>
				)}

				{website && (
					<View style={styles.detailBox}>
						<View>
							<Image style={styles.detailIcon} src={IMAGE_PATHS.templateWebsiteIcon} />
						</View>
						<View>
							<Text style={styles.detailText}>{website}</Text>
						</View>
					</View>
				)}
			</View>
		</View>
	);
};

export default PersonalInfo;
